import { useCallback } from 'react';
import useIsTrackEnabled from './useIsTrackEnabled';
import useVideoContext from './useVideoContext';
export default function useLocalAudioToggle() {
  var _useVideoContext = useVideoContext(),
      localTracks = _useVideoContext.localTracks,
      onControlEvent = _useVideoContext.onControlEvent;

  var audioTrack = localTracks.find(function (track) {
    return track.kind === 'audio';
  });
  var isEnabled = useIsTrackEnabled(audioTrack);
  var toggleAudioEnabled = useCallback(function () {
    onControlEvent('toggleAudio', {
      isEnabled: !audioTrack.isEnabled
    });

    if (audioTrack) {
      audioTrack.isEnabled ? audioTrack.disable() : audioTrack.enable();
    }
  }, [audioTrack]);
  return [isEnabled, toggleAudioEnabled];
}